import { PureComponent } from "react";

import {
    CurrencyCell,
    type INumberResponse,
} from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrency";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    type GridColumn,
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

interface IUnitCostProps {
    cost: INumberResponse | null;
    unit: string;
}

class UnitCostCell extends PureComponent<
    IGridCellRenderProps<IUnitCostProps, GridColumn<IUnitCostProps>>
> {
    render() {
        const { cellValue } = this.props;
        if (!cellValue) {
            return null;
        }
        return cellValue?.cost !== null ? (
            <>
                <CurrencyCell
                    {...this.props}
                    cellValue={cellValue.cost}
                    shouldUseAccountingMode={false}
                />{" "}
                / {cellValue.unit}
            </>
        ) : null;
    }
}

export const columnUnitCost: IClientGridColumn<IUnitCostProps> = {
    columnType: GridColumnType.unitCost,
    Cell: UnitCostCell,
};
